module.exports = __webpack_public_path__ + "img/nothing.d97c2998.png";